import {Routes} from '@angular/router';
import {Create} from './components/create/create';
import {Start} from './components/start/start';
import {ClientGuard} from './client.guard';
import {Admin} from './components/admin/admin';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'create',
        pathMatch: 'full',
    },
    {
        path: 'start/:token/:hash',
        component: Start,
        canActivate: [ClientGuard],
    },
    {
        path: 'create/:token',
        component: Create,
        canActivate: [ClientGuard],
    },
    {
        path: 'admin/:token',
        component: Admin,
        canActivate: [ClientGuard],
    },
];
